import { CurrencyCode } from '@/shared/constants/currencies';
import { currencySelectors } from '@/features/shared/currency-selectors';
import { useCurrencyStore } from '@/features/shared/currency-store';

/**
 * The currency the visitor is billed in, derived from their detected country.
 *
 * Read-only by design — there is no currency picker any more, so this only ever changes
 * once per page load, when `RegionHydrator` resolves the region. Consumers go through
 * this hook rather than the store so the backing state stays an implementation detail.
 */
export function useCurrency(): CurrencyCode {
  return useCurrencyStore(currencySelectors.currency);
}
